import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { navigate } from 'gatsby';
import { getQueryParam } from 'lib/util';
import { useCreateSubscriptionMutation, useMeQuery, useUpdatePreferencesMutation } from 'lib/home/generated/queries';
import { RegistrationRouteMap, useAuthStore, useRegistrationStore } from '../../store';
import { Loading } from '../../components';

const OAuthRedirect = () => {
  const queryClient = useQueryClient();
  const { token } = useAuthStore();
  const { selectedPlan, preferences, checkoutInfo, promoCode, referralCode } = useRegistrationStore();
  const { mutate: mutateSubscriptions } = useCreateSubscriptionMutation({
    onSuccess: () => {
      return refetchMeData();
    }
  });
  const { mutate: mutatePreferences } = useUpdatePreferencesMutation({
    onSuccess: () => {
      return refetchMeData();
    }
  });
  const { data: meData, refetch: refetchMeData } = useMeQuery();

  useEffect(() => {
    if (!meData) return;

    if (!checkoutInfo?.postal_code && !meData.me?.postal_code) {
      navigate(RegistrationRouteMap.index);
      return;
    }

    if (preferences?.diets && !meData?.me.meal_preferences)
      return mutatePreferences({ updatePreferencesInput: { ...preferences } });

    if (selectedPlan && !meData?.me.subscription?.id && meData?.me.meal_preferences)
      return mutateSubscriptions({
        createUserSubscriptionInput: {
          product_variant_id: selectedPlan,
          promo_code: promoCode,
          referral_code: referralCode
        }
      });

    if (!selectedPlan && !meData?.me.subscription?.id) {
      navigate(RegistrationRouteMap.selectPlan);
      return;
    }

    if (!preferences && !meData?.me.meal_preferences) {
      navigate(RegistrationRouteMap.preferences);
      return;
    }

    const redirectPath = getQueryParam('redirect');

    if (redirectPath) {
      navigate(redirectPath);
      return;
    }

    navigate('/');
  }, [
    meData,
    mutatePreferences,
    mutateSubscriptions,
    preferences,
    queryClient,
    selectedPlan,
    token,
    refetchMeData,
    checkoutInfo,
    promoCode
  ]);

  return <Loading />;
};

const OAuthRedirectPage = () => {
  const { token, setToken } = useAuthStore();
  const queryToken = getQueryParam('token');

  if (!queryToken && !token) return null;
  if (queryToken !== token) setToken(queryToken);

  return <OAuthRedirect />;
};

export default OAuthRedirectPage;
